// This file is part of MinIO Console Server
// Copyright (c) 2021 MinIO, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.
//
// You should have received a copy of the GNU Affero General Public License
// along with this program.  If not, see <http://www.gnu.org/licenses/>.

import * as React from "react";
import { SVGProps } from "react";

const FileMusicIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      className={`min-icon`}
      fill={"currentcolor"}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-19.281 0 256 256"
    >
      <g data-name="Grupo 1552">
        <path
          data-name="Trazado 470"
          d="M216.997 77.195c.387-15.753.958-32.242-.5-47.941-1.093-11.756-6.193-21.735-17.832-25.915a42.466 42.466 0 00-5.016-1.447c-6.549-1.479-13.431-1.6-20.09-1.8-11.726-.345-23.448.365-35.176.314-23.494-.1-46.986.322-70.479.414q-4.228.016-8.456.017H17.242A17.261 17.261 0 00.001 18.079v220.679a17.26 17.26 0 0017.241 17.24h182.54a17.26 17.26 0 0017.241-17.24V128.813c-.002-17.184-.448-34.459-.026-51.618zm-20.921 145.986a14.889 14.889 0 01-14.888 14.889H32.819a14.89 14.89 0 01-14.889-14.889V33.659a14.888 14.888 0 0114.889-14.888h99.548v25.458a37.8 37.8 0 0037.756 37.76h25.952zm0-157.657h-25.952a21.32 21.32 0 01-21.295-21.3V18.766h32.359a14.887 14.887 0 0114.888 14.888z"
        />
        <path
          data-name="Trazado 471"
          d="M151.22 93.837l-67.656 9.02-.128.016a13.3 13.3 0 00-12.025 13.473v55.664a22.946 22.946 0 00-7.98-1.435 23.086 23.086 0 00-23.06 23.061 23.085 23.085 0 0023.06 23.058 23.084 23.084 0 0023.059-23.058V150.41c.361-4.418 1.57-5.6 2.015-5.89l58.69-7.827a1.448 1.448 0 01.764.239 1.855 1.855 0 01.25 1.174v23.663a22.994 22.994 0 00-7.981-1.433 23.086 23.086 0 00-23.059 23.059 23.085 23.085 0 0023.059 23.058 23.085 23.085 0 0023.059-23.058v-77.608c0-4.089-1.2-7.245-3.565-9.382a11.107 11.107 0 00-8.502-2.568zM63.431 201.611a7.988 7.988 0 01-7.979-7.979 7.989 7.989 0 017.979-7.98 7.99 7.99 0 017.98 7.98 7.989 7.989 0 01-7.984 7.98zm84.776-82.429c-.23 1.876-1.1 2.3-1.539 2.369l-57.957 7.728-.134.018a6.168 6.168 0 01-2.088 0v-8.793c0-2.208.833-2.8 1.762-3.063l58.3-7.776a2.288 2.288 0 011.444.261 1.969 1.969 0 01.215 1.139zm-7.979 72.19a7.991 7.991 0 01-7.98-7.981 7.991 7.991 0 017.98-7.981 7.991 7.991 0 017.981 7.979 7.993 7.993 0 01-7.989 7.984z"
        />
      </g>
    </svg>
  );
};

export default FileMusicIcon;
